import { render, staticRenderFns } from "./OddsCard.vue?vue&type=template&id=a732cf64&"
import script from "./OddsCard.vue?vue&type=script&lang=js&"
export * from "./OddsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports